import {getNotice, pageInfo} from '../api';
const home = {
  namespaced: true,
  state: {
    pageResp: {},
    getNoticeResp: {},
    detailInfoObj: null
  },
  mutations: {

  },
  actions: {

  }
}
export default home



// WEBPACK FOOTER //
// ./src/page/home/store/home.store.js